'use strict';

export default class Dropdown {
  constructor() {
    $('body').on('click', '.dropdown-menu[data-stop-propagation]', function(e) {
      e.stopPropagation();
    });
  }
}
